import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';
import {
  AppSurfaceStore,
  AuthStore,
  MANAGE_PATHS,
} from '@marineform/manage-data-access';

export const loginPageResolver: ResolveFn<boolean> = () => {
  const authStore = inject(AuthStore);
  const appSurfaceStore = inject(AppSurfaceStore);
  const navCtrl = inject(NavController);

  if (!authStore.isLoggedIn()) {
    return true;
  }

  const homePath = appSurfaceStore.homePath();
  if (homePath === `/${MANAGE_PATHS.LOGIN}`) {
    return true;
  }

  void navCtrl.navigateRoot(homePath);
  return false;
};
